<template>
    <footer>
        Copyright © 2024 <img src="@/assets/images/logo_pixnet.svg" alt="pixnet" />優像數位媒體科技 ( 股 ) 公司
    </footer>
</template>

<style lang="scss" scoped>
footer {
    position: relative;
    margin-top: -77px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 28px 0;
    font-size: 14px;
    color: #fff;
    background: #000;

    @media (max-width: 767px) {
        margin-top: -40px;
        padding: 12px 0;
        font-size: 12px;
        line-height: 16px;
    }

    img {
        margin: 0 20px;

        @media (max-width: 767px) {
            margin: 0 4px;
        }
    }
}
</style>
